module.exports = "/src/views/games/other/images/action/night.png";